import type { GetRevenueByCurrencyResponse } from '@weft/api-definition';
import { GetRevenueByCurrencyResponseSchema } from '@weft/api-definition';
import { validateNotNullOrUndefined } from '@weft/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useGetRevenueByCurrency(options?: CustomUseQueryOptions<GetRevenueByCurrencyResponse>) {
  const revenueByCurrencyQuery = useQuery(
    ['revenue-by-currency'],
    async () => {
      const privateApi = getPrivateApi();
      const revenueByCurrency = await privateApi.getRevenueByCurrency();

      return GetRevenueByCurrencyResponseSchema.parse(revenueByCurrency);
    },
    { 
      suspense: true,
      ...options,
    },
  );

  validateNotNullOrUndefined(revenueByCurrencyQuery.data, 'revenueByCurrencyQuery.data');

  return revenueByCurrencyQuery;
}